var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeGrey(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.90959 8.77126C2.76017 9.00262 2.64606 9.19607 2.56848 9.33333C2.64606 9.47059 2.76017 9.66404 2.90959 9.8954C3.22083 10.3773 3.68199 11.0186 4.28142 11.658C5.48942 12.9466 7.19974 14.1667 9.33332 14.1667C11.4669 14.1667 13.1772 12.9466 14.3852 11.658C14.9847 11.0186 15.4458 10.3773 15.7571 9.8954C15.9065 9.66404 16.0206 9.47059 16.0982 9.33333C16.0206 9.19607 15.9065 9.00262 15.7571 8.77126C15.4458 8.28934 14.9847 7.64804 14.3852 7.00864C13.1772 5.72011 11.4669 4.5 9.33332 4.5C7.19974 4.5 5.48942 5.72011 4.28142 7.00864C3.68199 7.64804 3.22083 8.28934 2.90959 8.77126Z",
    stroke: "#2C303B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33332 11.6667C8.04466 11.6667 6.99999 10.622 6.99999 9.33333C6.99999 8.04467 8.04466 7 9.33332 7C10.622 7 11.6667 8.04467 11.6667 9.33333C11.6667 10.622 10.622 11.6667 9.33332 11.6667Z",
    stroke: "#2C303B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeGrey);
export default __webpack_public_path__ + "static/media/eye-grey.c5f270e211fd1ca73ce98149066e3b5a.svg";
export { ForwardRef as ReactComponent };